import React, { useEffect, useRef, useState } from 'react'
import './mentoriaSwitcher.scss';

interface MentoriaSwitcherProps {
    options: Array<{ title: string, image: any, value: any }>;
    currentTab: number;
    setCurrentTab: any;
    onClick: any;
}


const MentoriaSwitcher = ({ options, currentTab, setCurrentTab }: MentoriaSwitcherProps) => {

    const [selected, setSelected] = useState<any>(options[0]);
    const [selectedElement, setSelectedElement] = useState<any>();
    const refArray = options.map(_ => useRef(null));

    const handleClick = (event: any, element: any) => {
        // setSelected(element);
        // setSelectedElement(event.target);
        // setCurrentTab(element.value)
        // console.log(event.target.offsetWidth);
    }

    useEffect(() => {
        setSelected(options.find((option) => option.value === currentTab));
        setSelectedElement(refArray[currentTab].current)
    }, [currentTab])


    return (
        <div className="a-mentoria-switcher">
            {options.map((element, idx) => (
                <div
                    className={`a-mentoria-switcher__section ${selected.value === element.value ? 'a-mentoria-switcher__section--selected' : ''}`}
                    onClick={(event) => handleClick(event, element)}
                    ref={refArray[idx]}
                    key={idx}
                >
                    <p>{element.title}</p>
                    <div className={`a-mentoria-switcher__section__icon ${selected.value === element.value ? 'a-mentoria-switcher__section__icon--selected' : ''}`}>
                        <img
                            src={element.image}
                            alt={element.title}
                            width={30}
                            height={30}
                        />
                    </div>
                </div>
            ))}
            <div
                className="a-mentoria-switcher__selected"
                style={{
                    left: (selectedElement?.offsetLeft + (selectedElement?.offsetWidth / 2)) - 20
                }}

            ></div>
        </div>
    )
}

export default MentoriaSwitcher